import { spread as r, mergeProps as e, insert as a, template as i } from "solid-js/web";
import { cn as o } from "../../utils/class.js";
var s = i("<button>");
const p = (n) => {
  return t = s(), r(t, e(() => ({ ...n, class: void 0 }), { get class() {
    return o(`
        rn-btn 
        rn-btn-ghost 
        ${n.setHeight ? "" : "rn-h-full"} 
        ${n.selected ? "" : "dark:hover:rn-bg-black-tie"}
        date-picker-main-btn 
        rn-min-h-0 
        rn-p-0
        motion-reduce:rn-no-animation
        motion-reduce:rn-transition-none
        `, { "rn-no-animation": n.noButtonAnimation }, n.class);
  }, "data-type": "date-picker-main-btn", type: "button" }), !1, !0), a(t, () => n.children), t;
  var t;
};
export {
  p as Button
};
